<template>
  <div class="root" ref="root">
    <van-nav-bar title="充值缴费" @click-left="onClickLeft"  left-arrow></van-nav-bar>
    <div class="top-bg"></div>
    <div class="card-info" ref="cardInfo">
      <div class="iccid-info">
        <div class="text-left">充值号：<span class="number">{{query.short_number?query.short_number:iccid}}</span></div>
        <div class="change-card"  @click="$router.push({name:'bind',query:{nostorage:1}})">切换</div>
      </div>
      <div class="status-info" v-if="query.simStatusName">
        <div class="text-left">状态：<span class="status-ok">{{query.simStatusName}}</span></div>
        <div class="auth">{{query.simAuthStatusName}}</div>
      </div>
      <div class="expire-info" v-if="query.settlementDate" style="color: #b30707;font-size: .5rem;font-weight: bolder">
        <template v-if="query.settlementDate">此卡月结日每月{{query.settlementDate}}号，充值时注意月结日</template>
      </div>
    </div>
    <div class="content" ref="content">

      <div class="recharge-check">
        <div class="check-1"  @click="$router.push({name:'recharge',query:{iccid:iccid,type:0,short_number:query.short_number}})">本月套餐立即生效 月结日到期清零</div>
        <div class="check-2" @click="$router.push({name:'recharge',query:{iccid:iccid,type:1,short_number:query.short_number}})">次月套餐 下个月结日生效 (提前充值选项)</div>
      </div>
      <div  class="bottom-tips">
        <div  class="title">温馨提示：</div>
        <ol>
          <li>1.本月套餐立即生效；</li>
          <li>2.次月套餐月结日后生效。</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
    function str2number(str) {
        str = str.replace("px","")
        return parseFloat(str)+0
    }
    export default {
      data(){
        return {
          init:false,
            iccid:"",
            query:{}
        }
      },
        mounted() {
          this.$refs.root.style.minHeight = document.querySelector("#app").style.minHeight;
        },
        created() {
            this.query = this.$route.query;
            this.iccid = this.query.iccid;
        }
    }
</script>

<style scoped lang="scss">
  .root{
    background: #fff;
    font-size: 0;
    position: relative;
    .top-bg{
      background: #fafafa;
      border-bottom-left-radius: .3rem;
      border-bottom-right-radius: .3rem;
      height: 1rem;
    }
    .content {
      position: fixed;
      bottom: .4rem;
      width: 100%;
      background: #fff;
      .bottom-tips {
        width: 6.9rem;
        margin: .3rem auto 0;
        background: #fff;
        .title {
          text-align: left;
          font-weight: bold;
          color: #242424;
          font-size: .26rem;
          line-height: 0.48rem;
        }

        li {
          text-align: left;
          color: #666666;
          line-height: .43rem;
          font-size: .24rem;
        }
      }

      .recharge-check {
        background: #fff;
        width: 6.9rem;
        margin: 0 auto;
        font-weight: bold;
        > div {
          width: 100%;
          height: .68rem;
          line-height: .68rem;
          text-align: center;
          border-radius: .2rem;
          font-size: .28rem;
        }

        .check-1 {
          background: #0353fe;
          color: #fff;
        }

        .check-2 {
          background: #0353fe;
          color: #fff;
          margin-top: .3rem;
        }
      }
    }
    .card-info {
      padding: .3rem;
      width: 6.3rem;
      border-radius: .3rem;
      background: #fff;
      margin: -.3rem auto 0;
      box-shadow: 0 0 .1rem #f2f6ff;
      .expire-info{
        font-size: .26rem;
        color: #242424;
        text-align: left;
      }
      .status-info{
        display: flex;
        line-height: .6rem;
        .text-left{
          flex: 1;
          text-align: left;
          font-size: .26rem;
          .status-ok{
            color: #4bd5d3;
          }
          .status-error{
            color: #e73535;
          }
        }
        .auth{
          flex: 1;
          text-align: right;
          color: #ffa34b;
          font-size: .24rem;
        }
      }
      .iccid-info {
        display: flex;
        line-height: .52rem;
        .text-left {
          width: 100%;
          font-size: .3rem;
          font-weight: bold;
          text-align: left;
          .number {
            color: #0051fe;
            text-align: left;
          }
        }

        .change-card {
          width: 1rem;
          text-align: center;
          font-size: .26rem;
          color: #fff;
          background: #0051fe;
          border-radius: .12rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/recharge_check.vue